import { parseCookie } from '../core/util';
export default function (undefined, callback) {
  // eslint-disable-next-line no-unused-vars
  const cookie = parseCookie(document.cookie);
  callback({});
}
